import Order from ".";

export const orderRoutes = (data) => {
  return [
    {
      path: "/:lang/admin/order",
      title: "order",
      layout: "admin",
      routeType: "admin",
      component: Order,
    },
  ];
};
